import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import EventIcon from './EventIcon';

function formatDateRange(route) {
  const date1 = moment(route.start);
  const date2 = moment(route.end);
  let days = date1.format('MMM DD');
  if (!date2.isValid()) {
    return days;
  }
  if (!date1.isSame(date2)) {
    days = `${days}-${date2.format('DD')}`;
  }
  return days;
}

class EventBadgeItem extends React.Component {
  constructor() {
    super();
    this.state = {
      location: null
    };
  }
  componentWillMount(){
    if (this.props.event.place.city == null){
      this.setState({
        location: `${this.props.event.place.state}, ${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.state == null){
      this.setState({
        location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.city == null && this.props.event.place.state == null){
      this.setState({
        location : `${this.props.event.place.country}`,
      })
    }
    if (this.props.event.place.city != null && this.props.event.place.state != null && this.props.event.place.country != null){
      if (this.props.event.place.city === this.props.event.place.state){
        this.setState({
        location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
      })
      } else{
        if (this.props.event.place.state === this.props.event.place.country){
          this.setState({
            location: `${this.props.event.place.city}, ${this.props.event.place.country}`,
          })
        }else{
          this.setState({
            location: `${this.props.event.place.city}, ${this.props.event.place.state}, ${this.props.event.place.country}`,
          })
        }
       }
    }
  }
  render() {
    const event = this.props.event;
    return (
      <li key={event.id} className="item" data-route={event.id}>
        <div className="event-date">
          <strong className="event-day">{formatDateRange(event)}</strong>{' '}
          <EventIcon eventType={event.event_type} />
        </div>
        <div className="event-location">
          <strong>
            <span>{event.name && event.name}</span>
          </strong>
          <span>
            ({this.state.location})
          </span>
          <span>{event.notes}</span>
        </div>
      </li>
    );
  }
}

EventBadgeItem.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    event_type: PropTypes.string,
  }).isRequired,
};
export default EventBadgeItem;



// WEBPACK FOOTER //
// src/routes/tours/components/EventBadgeItem.js